module.exports = __webpack_public_path__ + "img/lichtmast.6ff838cb.png";